angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/projects/post/post-project.html',
    '<update-title title="Find Engineers Near Me | Post Your Request Now | PEforHire.com"></update-title>\n' +
    '<update-meta name="description" content="Fill out the project request form and submit. Receive proposals and compare bids from highly qualified licensed Professional Engineers (PEs) for FREE!  P.E. For Hire is fast and intuitive, allowing you to get the engineering expertise you need, when you need it. Post today, hire tomorrow!"></update-meta>\n' +
    '<!-- Post Project -->\n' +
    '<section class="content dashboard post-project-get-started">\n' +
    '    <div class="container">\n' +
    '        <div class="row">\n' +
    '            <form>\n' +
    '                <div class="col-xs-12 get-started-box">\n' +
    '                    <div class="progress-bar-wizard" ng-show="!isClient && currentStep!=1 && currentStep <= 7">\n' +
    '                        <uib-progressbar value="currentProgress"></uib-progressbar>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 1 -->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==1">\n' +
    '                        <img class="img-lori" src="https://salesiq.zohopublic.com/peforhire/fgravatar/1538437641399_343015000000002043/photo.ls">\n' +
    '                        <span class="font-title big bold">Hi! I\'m Lori.</span>\n' +
    '                        <span class="font-title middle">What is your name?</span>\n' +
    '                        <div class="separator" />\n' +
    '                        <div class="flex-row">\n' +
    '                            <input ng-model="wizardData.firstname" maxlength="50" class="mr-medium form-control input-lg"\n' +
    '                                id="firstname" name="firstname" type="text" placeholder="First Name" required="true" />\n' +
    '                            <input ng-model="wizardData.lastname" maxlength="50" class="form-control input-lg" id="lastname"\n' +
    '                                name="lastname" type="text" placeholder="Last Name" required="true" />\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 2 -->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==2">\n' +
    '                        <h5 class="font-title middle">What type of engineer do you&nbsp;need?</h5>\n' +
    '                        <div class="separator" />\n' +
    '                        <div>\n' +
    '                            <label class="select input-type">\n' +
    '                                <select ng-options="item.Label for item in licenses" ng-model="wizardData.engType"\n' +
    '                                    class="form-control input-lg" required="true" name="wizardData.engType">\n' +
    '                                    <option value="">Select...</option>\n' +
    '                                </select>\n' +
    '                            </label>\n' +
    '                            <div class="separator" />\n' +
    '                            <a href="" ng-click="openZoho()">Not Sure?</a>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 3 -->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==3">\n' +
    '                        <div class="half">\n' +
    '                            <h5 class="font-title middle">What is the best email address to send your free quotes&nbsp;to?</h5>\n' +
    '                            <div class="separator"></div>\n' +
    '                            <div class="flex-row fifty">\n' +
    '                                <input ng-model="wizardData.email" maxlength="50" class="form-control input-lg"\n' +
    '                                    name="email" type="email" placeholder="Email Address" required="true" ng-blur="userExists(wizardData.email)" />\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 4 -->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==4">\n' +
    '                        <div class="half">\n' +
    '                            <h5 class="font-title middle">Tell us about your project.</h5>\n' +
    '                            <h5 class="font-title middle">What do you need the engineer to&nbsp;do?</h5>\n' +
    '                            <div class="separator" />\n' +
    '                            <div class="flex-row">\n' +
    '                                <textarea ng-model="wizardData.projectDetails" rows="4" maxlength="2000" class="form-control"\n' +
    '                                    id="email" name="email" type="text" placeholder="Provide as much detail as you can. Some examples may include: dimensions, assessor&#39;s parcel number, number of stories of dwelling, etc." required="true" />\n' +
    '                                </div>\n' +
    '                            <div class="separator small" />\n' +
    '                            <div class="flex-row spaceb">\n' +
    '                                <span>Attach a photo, sketch or drawing</span>\n' +
    '                                <a href="" ng-click="openZoho()">Not Sure?</a>\n' +
    '                            </div>\n' +
    '                            <div class="separator small" />\n' +
    '                            <!-- Attachment -->\n' +
    '                            <div class="flex-row">\n' +
    '                                <span class="btn btn-primary btn-file">\n' +
    '                                    Attach File\n' +
    '                                    <input type="file" ngf-select ng-model="file" id="file" name="file" ngf-max-size="20MB" ngf-validate-force="true" ngf-validate="{size: {max: \'20MB\'}}"\n' +
    '                                        accept=".gif, .jpg, .png, .pdf, .jpeg, .doc, .docx, .xls, .xlsx, .ppt, .pptx" class="btn btn-default mr-medium">\n' +
    '                                </span>\n' +
    '                                <span id="file-attached" class="">\n' +
    '                                    <small>{{file.name}}</small>\n' +
    '                                    <a ng-show="file.name" href="javascript:;" class="trash" ng-click="removeFile()"></a>\n' +
    '                                </span>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                        <div class="row">\n' +
    '                            <div class="help-block" ng-class="{ \'errors\': postProject.file.$invalid }" ng-messages="postProject.file.$error">\n' +
    '                                <div ng-message="maxSize">\n' +
    '                                    <p>File is too large, it must be smaller than 20 Mb</p>\n' +
    '                                </div>\n' +
    '                                <div ng-message="accept">\n' +
    '                                    <p>File must be a PDF, GIF, JPG or PNG</p>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 5 -->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==5">\n' +
    '                        <h5 class="font-title middle">Where is your project&nbsp;located?</h5>\n' +
    '                        <div class="separator" />\n' +
    '                        <div class="form-group">\n' +
    '                            <div class="flex-row seventy-five spaceb">\n' +
    '                                <input ng-model="wizardData.address" maxlength="256" class="mr-medium form-control input-lg"\n' +
    '                                    id="address" name="address" type="text" placeholder="Address" />\n' +
    '                                <input ng-model="wizardData.zipCode" maxlength="5" class="mr-medium form-control input-lg"\n' +
    '                                    id="zip_code" name="zip_code" type="text" placeholder="ZIP code *" ng-keyup="getZipInfo()"/>\n' +
    '                            </div>\n' +
    '                            <div class="separator small"></div>\n' +
    '                            <div class="flex-row seventy-five spaceb">\n' +
    '                                <input ng-model="wizardData.city" maxlength="50" class="mr-medium form-control input-lg"\n' +
    '                                    id="city" name="city" type="text" placeholder="City" readonly />\n' +
    '                                <input ng-model="wizardData.state" maxlength="50" class="mr-medium form-control input-lg"\n' +
    '                                    id="state" name="state" type="text" placeholder="State" readonly />\n' +
    '                            </div>\n' +
    '                            <div class="separator small"></div>\n' +
    '                            <div class="flex-row seventy-five spaceb">\n' +
    '                                <p>* ZIP code is required.</p>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 6 -->\n' +
    '                    <div class="flex-column center" id="step6" ng-show="currentStep==6">\n' +
    '                        <h5 class="font-title middle">When do you need the work completed&nbsp;by?</h5>\n' +
    '                        <div class="separator" />\n' +
    '                        <div class="flex-column">\n' +
    '                            <ul class="list-inline radio-button-options">\n' +
    '                                <div class="rate-option" ng-repeat="c in completed_by_options">\n' +
    '                                    <input class="form-control input-lg" ng-model="wizardData.completed_by" type="radio" ng-value="c">\n' +
    '                                    <label for="onsite-week" ng-click="wizardData.completed_by=c">\n' +
    '                                        <span></span>{{c.text}}\n' +
    '                                    </label>\n' +
    '                                </div>\n' +
    '                            </ul>\n' +
    '                            <!-- If the last option is selected -->\n' +
    '                            <div class="separator small" />\n' +
    '                            <div class="form-group" ng-show="wizardData.completed_by == completed_by_options[3]">\n' +
    '                                <p class="input-group pe4h-datepicker-input post">\n' +
    '                                    <input name="closeDate" required="true" ng-pattern=\'/^[0-9]{2}\\-[0-9]{2}\\-[0-9]{4}$/i\' type="text" class="form-control pe4h-datepicker"\n' +
    '                                        show-button-bar="false" uib-datepicker-popup="MM-dd-yyyy" ng-model="wizardData.completed_by_date" is-open="popup.opened"\n' +
    '                                        datepicker-options="datepicker.options" close-text="Close" alt-input-formats="altInputFormats"\n' +
    '                                    />\n' +
    '                                    <span class="input-group-btn">\n' +
    '                                        <button type="button" class="btn btn-default btn-icon-calendar" ng-click="open()">\n' +
    '                                            <i class="glyphicon glyphicon-calendar"></i>\n' +
    '                                        </button>\n' +
    '                                    </span>\n' +
    '                                </p>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Step 7 -->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==7">\n' +
    '                        <div class="half">\n' +
    '                            <h5 class="font-title middle">Give your project a&nbsp;name</h5>\n' +
    '                            <div class="separator" />\n' +
    '                            <div class="flex-column">\n' +
    '                                <div class="flex-row seventy-five">\n' +
    '                                    <input ng-model="wizardData.project_name" maxlength="50" class="form-control input-lg" id="project_name"\n' +
    '                                        name="project_name" placeholder="Design a retaining wall" required="true" />\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Enter your password-->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==8">\n' +
    '                        <div class="half">\n' +
    '                            <h5 class="font-title middle">Enter your password</h5>\n' +
    '                            <div class="separator" />\n' +
    '                            <div class="flex-column">\n' +
    '                                <div class="flex-column fifty">\n' +
    '                                    <input ng-model="wizardData.password" type="password" maxlength="150" class="form-control input-lg" id="password"\n' +
    '                                        name="password" placeholder="Password" required="true" />\n' +
    '                                    <div class="separator"></div>\n' +
    '                                    <a href="" ng-click="forgotPassword()">Forgot password?</a>\n' +
    '                                    <div class="separator"></div>\n' +
    '                                    <div class="flex-row center get-started-buttons">\n' +
    '                                        <button type="button" class="btn btn-secondary mr-low back" ng-click="previousStep()" ng-if="currentStep!=1">BACK</button>\n' +
    '                                        <button ng-disabled="!validateStep(currentStep)" type="button" class="btn btn-primary" ng-click="login()">\n' +
    '                                            LOG IN\n' +
    '                                        </button>\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- You\'re finished-->\n' +
    '                    <div class="flex-column center" ng-show="currentStep==9" id=\'finished\'>\n' +
    '                        <div class="half">\n' +
    '                            <h5 class="font-title big bold">You\'re Finished!</h5>\n' +
    '                            <h5 class="font-title middle">We are matching engineers to your&nbsp;project.</h5>\n' +
    '                            <h5 class="font-title middle">Your free quotes are on the&nbsp;way.</h5>\n' +
    '                            <div class="separator" />\n' +
    '                            <button type="button" class="btn btn-primary" ng-click="goToHome()">CLOSE</button>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '\n' +
    '                    <!-- Footer buttons -->\n' +
    '                    <div class="separator" />\n' +
    '                    <div class="flex-row center get-started-buttons" ng-show="currentStep <= 7">\n' +
    '                        <button type="button" class="btn btn-secondary mr-low back" ng-click="previousStep()" ng-if="(currentStep >= 3) || (currentStep==2 && !isClient)">BACK</button>\n' +
    '                        <button ng-disabled="!validateStep(currentStep)" type="button" class="btn btn-primary" ng-click="nextStep()">\n' +
    '                            {{currentStep!= 7? \'NEXT\': \'SUBMIT\'}}\n' +
    '                        </button>\n' +
    '                    </div>\n' +
    '                    <div class="separator" ng-show="currentStep==7"/>\n' +
    '                    <div class="flex-row center" id="terms" ng-show="currentStep==7">\n' +
    '                        <span>By clicking "SUBMIT" you agree to the <a href="" ui-sref="terms" target="_blank" rel="noopener">Terms and Conditions</a> of P.E. For Hire.</span>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </form>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</section>\n' +
    '\n' +
    '<!-- Modals -->\n' +
    '<script type="text/ng-template" id="modal-professional-email.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" ng-click="$close();">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">OOPS!</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>We\'re sorry, but this email address is associated with an engineer\'s profile.</p>\n' +
    '        <p>You must enter a different email address to continue.</p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <a class="btn btn-primary" href="" ng-click="$close();" aria-label="Close">Close</a>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<script type="text/ng-template" id="modal-forgot-password.html">\n' +
    '    <div class="modal-header">\n' +
    '        <a class="close" ng-click="$close();">\n' +
    '            <i class="fa fa-times"></i>\n' +
    '        </a>\n' +
    '        <h4 class="modal-title">Password reset</h4>\n' +
    '    </div>\n' +
    '    <div class="modal-body">\n' +
    '        <p>An email containing a link to reset your password has been sent to:\n' +
    '            {{wizardData.email}}\n' +
    '        </p>\n' +
    '    </div>\n' +
    '    <div class="modal-footer">\n' +
    '        <a class="btn btn-primary" href="" ng-click="$close();" aria-label="Close">Close</a>\n' +
    '    </div>\n' +
    '    \n' +
    '</script>');
}]);
